<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Register</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form ref="form" @submit.prevent="onRegister()">
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="person"
                                    name="firstName"
                                    label="First Name"
                                    :error-messages="errors.collect('firstName')"
                                    data-vv-name="firstName"
                                    data-vv-as="First Name"
                                    required
                                    v-model="firstName"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="person"
                                    name="lastName"
                                    label="Last Name"
                                    :error-messages="errors.collect('lastName')"
                                    data-vv-name="lastName"
                                    data-vv-as="Last Name"
                                    required
                                    v-model="lastName"
                            ></v-text-field>
                            <v-text-field
                                v-validate="'required|email'"
                                prepend-icon="email"
                                name="email"
                                label="Email (NOT hotmail, gmail etc)"
                                :error-messages="errors.collect('email')"
                                data-vv-name="email"
                                data-vv-as="Email"
                                required
                                v-model="email"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="business"
                                    name="company"
                                    label="Company"
                                    :error-messages="errors.collect('company')"
                                    data-vv-name="company"
                                    data-vv-as="Company"
                                    required
                                    v-model="company"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required'"
                                    prepend-icon="call"
                                    name="telephone"
                                    label="Telephone"
                                    :error-messages="errors.collect('telephone')"
                                    data-vv-name="telephone"
                                    data-vv-as="Telephone"
                                    required
                                    v-model="directDialNumber"
                            ></v-text-field>
                            <v-text-field
                                    v-validate="'required|min:8'"
                                    prepend-icon="lock"
                                    name="password"
                                    label="Password"
                                    v-model="password"
                                    ref="password"
                                    type="password"
                                    :error-messages="errors.collect('password')"
                                    data-vv-name="password"
                                    data-vv-as="Password"
                                    required
                            >
                            </v-text-field>
                            <v-text-field
                                    v-validate="'required|min:8|confirmed:password'"
                                    data-vv-name="confirm"
                                    data-vv-as="Password"
                                    ref="confirm"
                                    :error-messages="errors.collect('confirm')"
                                    prepend-icon="lock"
                                    label="Confirm New Password"
                                    v-model="confirm"
                                    name="confirm"
                                    type="password">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="errors.any()" color="primary" @click="onSubmit()">Register</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { RepositoryFactory } from '../../repositories/RepositoryFactory'
const SecurityRepository = RepositoryFactory.get('security')

export default {
  name: 'Register',
  components: {
  },
  data () {
    return {
      isSubmitting: false,
      email: process.env.VUE_APP_REGISTER_EMAIL,
      directDialNumber: process.env.VUE_APP_REGISTER_DIRECT_DIAL_NUMBER,
      password: process.env.VUE_APP_REGISTER_PASSWORD,
      confirm: process.env.VUE_APP_REGISTER_PASSWORD,
      firstName: process.env.VUE_APP_REGISTER_FIRST_NAME,
      lastName: process.env.VUE_APP_REGISTER_LAST_NAME,
      company: process.env.VUE_APP_REGISTER_COMPANY
    }
  },
  created () {
    // this.reset()
  },
  methods: {
    handleAxiosError (error) {
      if (error.response) {
        // The request was made and the server responded with a status code that falls out of the range of 2xx
        this.$snotify.error(`${error.response.status}:${error.response.data.data.error}`)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        this.$log.debug(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        this.$log.debug(error.message)
      }
    },
    reset () {
      this.validator.reset()
      this.email = process.env.VUE_APP_REGISTER_EMAIL
      this.directDialNumber = process.env.VUE_APP_REGISTER_DIRECT_DIAL_NUMBER
      this.password = process.env.VUE_APP_REGISTER_PASSWORD
      this.confirm = process.env.VUE_APP_REGISTER_PASSWORD
      this.firstName = process.env.VUE_APP_REGISTER_FIRST_NAME
      this.lastName = process.env.VUE_APP_REGISTER_LAST_NAME
      this.company = process.env.VUE_APP_REGISTER_COMPANY
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.onRegister()
        } else {
          this.$snotify.error(this.$validator.errors.all())
        }
      })
    },
    async onRegister () {
      try {
        this.isSubmitting = true
        const response = await SecurityRepository.register(this, {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          direct_dial_number: this.directDialNumber,
          company: this.company,
          password: this.password,
          confirm: this.confirm
        })
        this.isSubmitting = false
        if (!response) {
          this.$snotify.error('Invalid response from server.')
        } else {
          this.$snotify.success(response.data.data.success)
          this.$router.push({ name: 'home' })
        }
      } catch (error) {
        this.handleAxiosError(error)
      }
    }
  }
}
</script>

<style scoped>

</style>
